import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconCoin1"><Path fillRule="evenodd" clipRule="evenodd" d="M8.59709 3.82273C5.71609 4.81863 3.5 8.01813 3.5 12C3.5 15.9819 5.71609 19.1814 8.5971 20.1773C6.3984 18.3447 5 15.3215 5 12C5 8.67854 6.39839 5.65527 8.59709 3.82273ZM13.5 22H10.5C5.68675 22 2 17.3931 2 12C2 6.60693 5.68675 2 10.5 2H13.5C18.3132 2 22 6.60693 22 12C22 17.3931 18.3132 22 13.5 22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoin1;
